import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'
import { AppConfigService } from '../../app.config';
import { DisplayModes } from '../../models/enums';
import { Competitor } from '../../models/lookups/competitor.model';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { SettingService } from '../../settings/components/settings/setting.service';
import { Setting } from '../../settings/models/setting.model';
import { CompetitorService } from './competitor.service';
import { ItemService } from '../item/item.service';
import { ItemBrandService } from '../item-brand/item-brand.service';
import { Item } from '../../models/lookups/item.model';
import { ItemBrand } from '../../models/lookups/item-brand.model';

@Component({
  selector: 'crm-competitor',
  templateUrl: './competitor.component.html',
  styleUrls: ['./competitor.component.css']
})
export class CompetitorComponent implements OnInit {

  competitors: Competitor[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  visitsByItems: boolean = false;
  items: Item[] = [];
  itemBrands: ItemBrand[] = [];
  selectedItem: Item;
  selectedItemBrand: ItemBrand;
  public logo = require("../../../app/assets/images/demo/Icon_Items Format.png");

  csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'Competitors List :',
    useBom: true,
    noDownload: false,
    headers: ["ID", "Name", "Item/Brand"]
  };

  selectedCompetitorId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  @ViewChild('filterModal')
  filterModal: ModalDirective;

  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly competitorService: CompetitorService,
    private readonly settingService: SettingService,
    private readonly itemService: ItemService,
    private readonly itemBrandService: ItemBrandService,
    private accountService: AccountService) { }


  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.settingService.getAllSettings().subscribe(response => {
      let settings = response as Setting[];
      this.visitsByItems = settings.find(x => { return x.key == "visitsByItems"; }).value == 'True';

      if (this.visitsByItems) {
        this.itemService.getAllItemsMiniUnscoped().subscribe(itemsResponse => {
          this.items = itemsResponse as Item[];
        });
      } else {
        this.itemBrandService.getAll().subscribe(brandsResponse => {
          this.itemBrands = brandsResponse as ItemBrand[];
        });
      }

      this.getCompetitors();
    });
  }

  getCompetitors() {
    this.displayMode = DisplayModes.Loading;
    let itemId = this.selectedItem ? this.selectedItem.id : undefined;
    let itemBrandId = this.selectedItemBrand ? this.selectedItemBrand.id : undefined;
    this.competitorService.search(this.searchText, itemId, itemBrandId).subscribe(response => {
      let result = response as Competitor[];
      this.competitors = result.filter(c => this.visitsByItems ? (c.itemId != null) : (c.itemBrandId != null));
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get competitors');
        console.log(err);
      })
  }

  gotoNew() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedCompetitorId = id;
    this.addNew = true;
  }

  confirmDelete(competitor) {
    this.selectedCompetitorId = competitor;
    this.deleteModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.performDelete(this.selectedCompetitorId, false);
  }

  private performDelete(competitor, force: boolean) {
    this.competitorService.delete(competitor.id, force).subscribe(response => {
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);

      let index = this.competitors.indexOf(competitor);
      this.competitors.splice(index, 1);
    }, error => {
      let message = error && error.error && error.error.Message ? error.error.Message : "Failed to delete competitor";
      if (!force && error && error.status === 503) {
        this.alertService.showDialog(message + ". Force delete anyway? This will remove it from every visit that used it.", DialogType.Confirm,
          () => this.performDelete(competitor, true),
          () => { });
      } else {
        this.alertService.showMessage("", message, MessageSeverity.Error);
      }
    });
  }

  downloadCSV() {
    const csvData = this.competitors.map(o => {
      return {
        id: o.id, name: o.name, itemOrBrand: this.visitsByItems ? o.itemName : o.itemBrandName
      };
    });
    this.csvOptions.headers = ["ID", "Name", this.visitsByItems ? "Item" : "Brand"];
    new AngularCsv(csvData, "CompetitorsList", this.csvOptions);
  }

  get canManageCompetitors() {
    return this.accountService.userHasPermission(Permission.manageCompetitorsPermission);
  }

  closeAdding(event) {
    this.selectedCompetitorId = undefined;
    this.addNew = false;
    if (event) {
      this.getCompetitors();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  openFilterModal() {
    this.filterModal.show();
  }

  hideFilterModal() {
    this.filterModal.hide();
  }

  searchFilterModal() {
    this.hideFilterModal();
    this.getCompetitors();
  }

}
